// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".googleplay {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
